import { unreadNotificationCount } from '/@/modules/notification/store/notification.state';

export function getUnreadNotificationCount(): number {
  return unreadNotificationCount.value;
}
